import { createMuiTheme } from "@material-ui/core/styles";

export const colors = {
  queenBlue: "#1d3557",
  spaceCadet: "#457b9d",
  lightBlue: "#a8dadc",
  honeyDew: "#f1faee",
  desire: "#e63946"
};

export function getCurrentTheme() {
  let theme = null;
  if (window && window.localStorage) {
    theme = window.localStorage.getItem("altola-optimus-theme");
  }
  switch (theme) {
    case "Altola":
      return altolaTheme;
    case "Sitecore":
      return sitecoreTheme;
    default:
      return altolaTheme;
  }
}

export const altolaTheme = createMuiTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: colors.queenBlue
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contast with palette.primary.main
    },
    secondary: {
      light: colors.lightBlue,
      main: colors.desire,
      // dark: will be calculated from palette.secondary.main,
      contrastText: colors.honeyDew
    }
    // error: will use the default color
  }
});

export const sitecoreTheme = createMuiTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#DA352C",
      dark: "#A21D16",
      light: "#D22C26"
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contast with palette.primary.main
    },
    secondary: {
      light: "#55B7DD",
      main: "#2591BC",
      // dark: will be calculated from palette.secondary.main,
      contrastText: "#474747"
    }
    // error: will use the default color
  }
});



// WEBPACK FOOTER //
// ./src/Constants.js